export const Resource = {
  MKS_CLUSTER_REGIONAL: 'mks_cluster_regional',
  MKS_CLUSTER_ZONAL: 'mks_cluster_zonal'
}

export const Group = {
  RU_1: 'ru-1',
  RU_2: 'ru-2',
  RU_3: 'ru-3',
  RU_7: 'ru-7',
  RU_8: 'ru-8'
}